/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceDates
 */
export interface ServiceDates {
    /**
     * Start date in YYYY-MM-DD format
     */
    start: Date;
    /**
     * End date in YYYY-MM-DD format
     */
    end?: Date;
}

/**
 * Check if a given object implements the ServiceDates interface.
 */
export function instanceOfServiceDates(value: object): value is ServiceDates {
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function ServiceDatesFromJSON(json: any): ServiceDates {
    return ServiceDatesFromJSONTyped(json, false);
}

export function ServiceDatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceDates {
    if (json == null) {
        return json;
    }
    return {
        
        'start': (json['start'] == null ? json['start'] : parseDate(json['start'])),
        'end': json['end'] == null ? undefined : (parseDate(json['end'])),
    };
}

export function ServiceDatesToJSON(json: any): ServiceDates {
    return ServiceDatesToJSONTyped(json, false);
}

export function ServiceDatesToJSONTyped(value?: ServiceDates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'] == null ? value['start'] : serializeDate(value['start']),
        'end': value['end'] == null ? value['end'] : serializeDate(value['end']),
    };
}

